export default {
  bg: require('../assets/images/core-bg.jpg').default,
  sovtechLogo: require('../assets/images/sovtech-small.png').default,
  404: require('../assets/images/404.svg').default,
  noData: require('../assets/images/no-data.png').default,
  oddoBHFLogo: require('../../src/assets/images/oddoBHFLogo.svg').default,
  LucaniaLogoRed: require('../../src/assets/images/LucaniaLogoRed.svg').default,
  lucaniaLogo: require('../../src/assets/images/lucianaLogo.jpg').default,
  aesaraPartnersLogo: require('../assets/images/aesaraPartnersLogo.svg').default,
  welcomeImage: require('../../src/assets/images/welcome.svg').default,
  detailsImage: require('../../src/assets/images/details.svg').default,
  successImage: require('../../src/assets/images/success.svg').default,
  myWorkImage: require('../../src/assets/images/myWork.svg').default,
  microsoft: require('../assets/images/microsoft.png').default,
  aesaraGif: require('../assets/images/Aesara-Lucania-2.gif').default,
  ellipse1: require('../../src/assets/images/Ellipse 4.svg').default,
  ellipse2: require('../../src/assets/images/Ellipse 7.svg').default,
  ellipse3: require('../../src/assets/images/Ellipse 8.svg').default,
  ellipseYellow: require('../assets/images/Ellipseyellow.svg').default,
  ellipseGrey: require('../assets/images/Ellipsegrey.svg').default,
  mrsimage: require('../assets/images/mrsimage.svg').default,
  rectangle75: require('../assets/images/Rectangle 75.svg').default,
  jodie: require('../assets/images/jodie.svg').default,
  ellipse4: require('../assets/images/Ellipsegrey4.svg').default,
  Lady1: require('../assets/images/lady1.svg').default,
  rectangleyellow74: require('../assets/images/Rectangleyellow74.svg').default,
  redCircle: require('../assets/images/circle.svg').default,
  ellipseTopRight: require('../assets/images/ellipseTopRight.svg').default,
  arrowNextIcon: require('../assets/images/arrowNextIcon.svg').default,
  downloadAppIosStep1: require('../assets/images/downloadApp/iOS/step1.svg').default,
  downloadAppIosStep2: require('../assets/images/downloadApp/iOS/step2.svg').default,
  downloadAppIosStep3: require('../assets/images/downloadApp/iOS/step3.svg').default,
  downloadAppIosStep4: require('../assets/images/downloadApp/iOS/step4.svg').default,
  downloadAppAndroidStep1: require('../assets/images/downloadApp/android/step1.svg').default,
  downloadAppAndroidStep2: require('../assets/images/downloadApp/android/step2.svg').default,
  downloadAppAndroidStep3: require('../assets/images/downloadApp/android/step3.svg').default,
  downloadAppAndroidStep4: require('../assets/images/downloadApp/android/step4.svg').default,
  addNote: require('../assets/images/addnote.svg').default,
  moduleComplete: require('../assets/images/moduleComplete.svg').default,
  upload: require('../assets/images/upload.svg').default,
  pdfIcon: require('../assets/images/Rectangle 125.svg').default,
  file: require('../assets/images/Vector.svg').default,
  darkTrash: require('../assets/images/darkTrash.svg').default,
  notePad: require('../assets/images/Notepad.svg').default,
  getStarted: require('../assets/images/getStarted.svg').default,
  getStartedMobile: require('../assets/images/getStartedMobile.png').default,
  textQuote: require('../assets/images/textQuote.svg').default,
  dashboardImage: require('../assets/images/dashboardImage.svg').default,
  notepadPen: require('../assets/images/Notespad.svg').default,
  bin: require('../assets/images/Bin.svg').default,
  newAesaraLogo: require('../assets/images/aesaranew.svg').default,
  nodata: require('../assets/images/nodata.svg').default,
  emptyNotes: require('../assets/images/EmptyNotepad.svg').default,
  emptyModule: require('../assets/images/EmptyModule.svg').default,
  sectionModuleComplete: require('../assets/images/moduleComplete.png').default,
  sectionEventsComplete: require('../assets/images/scheduleImage.png').default,
  footer: require('../assets/images/Group 232.svg').default
}
